import { render, staticRenderFns } from "./Importance.vue?vue&type=template&id=7b6798cd&"
import script from "./Importance.vue?vue&type=script&lang=js&"
export * from "./Importance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports